export function IndeedCampaignsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/indeed-campaigns.svg'"></ng-include>`
    }
}